export default {
    styleOverrides: {
        root: {
            textAlign: "left",
            justifyContent: "flex-start"
        }
    }
}
